import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class VehicleService {

    route = '/api/vehicle';
    blockViseRoute = '/api/vehicle/blockwise'

    constructor(private dataService: DataService) {
    };

    getOrderTypeLookUp(refresh: boolean) {
        return this.dataService.getData(this.route + '/ordertypelookup', refresh);
    }

    getOrderHistory(regNo: string, orderNo: string) {
        return this.dataService.getData(this.route + '/orderhistory?regNo=' + encodeURIComponent(regNo || '') + '&orderNo=' + encodeURIComponent(orderNo || ''), true);
    }

    saveOrder(data: any) {
        return this.dataService.post(this.route + '/order', data);
    }

    getLookUp(refresh: boolean) {
        return this.dataService.getData(this.route + '/lookup/', refresh);
    }

    getVehicleLookUp(data: any, refresh: boolean) {
        return this.dataService.getData(this.route + '/lookup/' + data, refresh);
    }
    getVehicleLookUpbyid(data: any, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/vehiclelookup/' + data, refresh);
    }

    getAllVehicleLookUpbyid(data: any, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/allvehiclelookup/' + data, refresh);
    }
    getVehicleListByBlockLevel(data: any, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/vehiclelookupblocklevel/' + data.subDivisionId + '/' + data.vehicleCategoryId + '/' + data.blockId, refresh)
    }
    getMachineryByRegNoForDepartment(subDivisionId: any, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/vehiclelookup/dept/' + subDivisionId, true)
    }
    getVehicleLookUpLogbook(data: any, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/vehiclelookup/logbook/' + data, refresh);
    }
    getVehicleList(data: any, refresh: boolean) {
        return this.dataService.getData(this.route + '/byclient/' + data, refresh);
    }
    get(clientId: number, refresh: boolean) {
        return this.dataService.getData(this.route + '/byclient/' + clientId, refresh);
    }
    getbyId(data: any, refresh: boolean) {
        return this.dataService.getData(this.route + '/' + data.region + '/' + data.division + '/' + data.subdivision, refresh);
    }

    getVechiclebyId(data: any, refresh: boolean) {
        return this.dataService.getData(this.blockViseRoute + '/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.block + '/' + data.financialYearId, refresh);
    }

    getbyquickentries(data: any, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/rollcall/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.financialYearId, refresh);
    }
    // get(data:any, refresh: boolean) {
    //     return this.dataService.getData(this.route + data.region + '/' +data.division+'/'+data.subdivision, refresh);
    // }
    getTreeVehicle(clientId: number, refresh: boolean) {
        return this.dataService.getData('/api/vehiclegroup/vehiclegroups/' + clientId, refresh);
    }
    getById(id: number, financialyearId:number,refresh: boolean,) {
        return this.dataService.getData(this.route + '/' + id + '/' + financialyearId ,refresh);
    }
    lastServiceGetById(id: number,financialYearId:number, refresh: boolean) {
        return this.dataService.getData('/api/transfer/lasttransfer/' + id +'/' + financialYearId, refresh);
    }

    transferImplementById(implementSubDivisionMappingId: number,financialyearId:number, refresh: boolean) {
        return this.dataService.getData('/api/implementtransfer/lasttransfer/' + implementSubDivisionMappingId + '/' + financialyearId , refresh);
    }

    getByvehicleId(vehicleId: number, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/vehiclesearch/' + vehicleId, refresh);
    }

    save(result: any) {
        return this.dataService.post('/api/vehicle', result).map(response => {
            this.dataService.clearRouteCache(this.route);
            return response;
        });
    }

    deleteMenu(id: number, status: number) {
        return this.dataService.post('/api/vehicle/update/' + id + '/' + status, null).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.route);
            return response;
        });
    }
    deactivateMenu(id: number, status: number) {
        return this.dataService.post('/api/implement/update/' + id + '/' + status, null).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.route);
            return response;
        });
    }
    deactivatedriver(id: number, status: number) {
        return this.dataService.post('/api/driver/update/' + id + '/' + status, null).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.route);
            return response;
        });
    }
    getMakeLookUp(id: number, refresh: boolean) {
        return this.dataService.getData(this.route + '/makelookup/' + id, refresh);
    }

    getImplementMakeLookUp(id: number, refresh: boolean) {
        return this.dataService.getData(this.route + '/implementmakelookup/' + id, refresh);
    }

    getMakeLookUpAll(id: number, refresh: boolean) {
        return this.dataService.getData('/api/lookup/vehiclemake/' + id, refresh);
    }

    getModelLookUpByMakeId(refresh: boolean, makeid) {
        return this.dataService.getData(this.route + '/modellookup/' + makeid, refresh);
    }

    getVehicleModelLookUpByMakeId(makeid: number, machineryType: number, refresh: Boolean) {
        return this.dataService.getData(this.route + '/modellookup/' + makeid + '/' + machineryType, refresh);
    }

    getPermitLookUp(refresh: boolean) {
        return this.dataService.getData(this.route + '/permitlookup', refresh);
    }

    getInsuranceProviderLookUp(refresh: boolean) {
        return this.dataService.getData(this.route + '/insuranceproviderlookup', refresh);
    }

    getRouteLookup(id: number, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/route/' + id, refresh);
    }
    downloadAttachment(id: number, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/attachment/' + id, refresh);
    }
    getRegnoList(region: number, divisionId: number, subDivisionId: number, categoryTypeId: number,financialyearId:number, refresh: boolean) {
        return this.dataService.getData('/api/lookup/regno/' + region + '/' + divisionId + '/' + subDivisionId + '/' + categoryTypeId  + '/' + financialyearId, refresh);
    }
    getVehicleTypeLookup(refresh: boolean) {
        return this.dataService.getData('/api/lookup/vehicletype', refresh);
    }
    getVehicleTypeList(data: any,refresh: boolean) {
        return this.dataService.getData('/api/mhirebooking/vehiclelist/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.financialyearId, refresh);
    }

    getVehiclegrouptype(refresh: boolean) {
        return this.dataService.getData('/api/lookup/vehiclegrouptype', refresh);
    }
    getTransferType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/transfertype', refresh);
    }

    gettransferlistById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/transfer/' + id, refresh);
    }
    getImplementstransferlistById(id: number,refresh: boolean) {
        return this.dataService.getData('/api/implementtransfer/' + id,refresh);
    }
    savetransfer(result: any) {
        return this.dataService.post('/api/transfer', result).map(response => {
            this.dataService.clearRouteCache(this.route);
            return response;
        });
    }
    saveImplementtransfer(result: any) {
        return this.dataService.post('/api/implementtransfer', result).map(response => {
            this.dataService.clearRouteCache(this.route);
            return response;
        });
    }
    updateReturn(result: any) {
        return this.dataService.post('/api/transfer/updatereturn', result).map(response => {
            this.dataService.clearRouteCache(this.route);
            return response;
        });
    }
    updateTransferReturn(result: any) {
        return this.dataService.post('/api/implementtransfer/updatereturn', result).map(response => {
            this.dataService.clearRouteCache(this.route);
            return response;
        });
    }

    getVehicleLookUpfforreport(data: any, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/vehiclelookup/' + data.subdivisionId + '/' + data.start + '/' + data.end, refresh);
    }

    updateVehicleSharedData(id: any, refresh: boolean) {
        return this.dataService.post('/api/vehicle/updatesharedvehicle/' + id, refresh)
    }

    getCeckedById(data: any, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/bookingAvailabilityupdate/' + data.vehicleId + '/' + data.bookingAvailabilityType, refresh);
    }
    vehicletargetFinancialyear(refresh: boolean) {
        return this.dataService.getData('/api/vehicletarget/financialyearlookup', refresh);
    }

    getDepartmentLookupData(refresh: boolean) {
        return this.dataService.getData('/api/lookup/departmentlookup', refresh);
    }

    getVehicleCategory(id: any, refresh: boolean) {
        return this.dataService.getData("/api/vehiclecategory/lookup/" + id, refresh)
    }
    getStageLookupData(eventType: any, isPlacedAtDealerPremises: boolean, refresh: boolean) {
        return this.dataService.getData('/api/lookup/eventTypeList/' + eventType + '/' + isPlacedAtDealerPremises, refresh);
    }
    saveSendBackCancel(result: any) {
        return this.dataService.post('/api/dbtfarmertarget/adminsendbackandcalcelupdate', result).map(response => {
            this.dataService.clearRouteCache(this.route);
            return response;
        });
    }

    getVehicleLookUpDatabyid(data: any, refresh: boolean) {
        return this.dataService.getData('/api/vehicle/vehicleData/' + data, refresh);
    }
}
